import { http } from './config'
import BaseService from './BaseService'

class GradeProdutoService extends BaseService {
    constructor() {
        super("/v1/grades-produtos");
    }
    listar(data){
        return http.get(`/v1/grades-produtos?produto_id=${data.produto_id}`)
    }
}

export default new GradeProdutoService();